import React, { useMemo, useState, useCallback, useEffect } from "react";
import Division from "./Division";

const QuestionUtils = ({
  isEmployee,
  questions: questionsProp = [],
  sectionId,
  subSectionId,
  answers,
  setAnswers,
  expandAll,
  fillFrom,
  onPrevious,
  onNext,
  canGoPrevious = false,
  canGoNext = false,
  onQuestionLoaded,
  handleAnswerChange: handleAnswerChangeProp,
}) => {
  const [optionsCache, setOptionsCache] = useState({});

  const handleAnswerChange = useCallback(
    (questionId, value, type) => {
      if (handleAnswerChangeProp) {
        handleAnswerChangeProp(questionId, value, type);
      } else {
        setAnswers((prev) => {
          // Multiselect: toggle the value in an array
          if (type === "multi-select" || type === "multiselect") {
            const prevArray = Array.isArray(prev[questionId])
              ? prev[questionId]
              : prev[questionId]
                ? [prev[questionId]]
                : [];
            const newArray = prevArray.includes(value)
              ? prevArray.filter((v) => v !== value)
              : [...prevArray, value];
            return { ...prev, [questionId]: newArray };
          }
          return { ...prev, [questionId]: value };
        });
      }
    },
    [setAnswers, handleAnswerChangeProp],
  );

  useEffect(() => {
    console.log(
      "QuestionUtils - Answers updated:",
      Object.keys(answers || {}).length,
    );
  }, [answers]);

  const questionsList = useMemo(() => {
    const flat = [];
    (questionsProp || []).forEach((division) => {
      (division.questions || []).forEach((q) => {
        flat.push(q);
      });
    });
    return flat;
  }, [questionsProp]);

  return (
    <div className="max-w-4xl mx-auto p-6">
      {(questionsProp || []).map((division) => (
        <Division
          key={division.divisionId || division._id || division.divisionTitle}
          isEmployee={isEmployee}
          division={division}
          answers={answers}
          setAnswers={setAnswers}
          handleAnswerChange={handleAnswerChange}
          questionsList={questionsList}
          optionsCache={optionsCache}
          setOptionsCache={setOptionsCache}
          onQuestionLoaded={onQuestionLoaded}
          expandAll={expandAll}
          fillFrom={fillFrom}
        />
      ))}

      {/* Navigation Buttons */}
      {(onPrevious || onNext) && (
        <div className="mt-8 mb-4">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <button
              type="button"
              onClick={onPrevious}
              disabled={!canGoPrevious}
              className={`px-6 py-2 rounded-lg font-medium transition-all flex items-center gap-2 ${
                !canGoPrevious
                  ? "bg-gray-400 text-gray-200 cursor-not-allowed opacity-50 text-xs"
                  : "text-white bg-[#06513D] hover:!bg-[#387464] active:scale-95 shadow-md text-xs"
              }`}
              style={{
                border: !canGoPrevious
                  ? "2px solid #9CA3AF"
                  : "2px solid white",
              }}
            >
              <span>←</span>
              Previous
            </button>

            <button
              type="button"
              onClick={onNext}
              disabled={!canGoNext}
              className={`px-6 py-2 rounded-lg font-medium transition-all flex items-center gap-2 ${
                !canGoNext
                  ? "bg-gray-400 text-gray-200 cursor-not-allowed opacity-50 text-xs"
                  : "text-white bg-[#06513D] hover:!bg-[#387464] active:scale-95 shadow-md text-xs"
              }`}
              style={{
                border: !canGoNext ? "2px solid #9CA3AF" : "2px solid white",
              }}
            >
              Next
              <span>→</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default QuestionUtils;
